import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ITdDataTableColumn, TdDataTableSortingOrder, TdDataTableService, TdDialogService, IPageChangeEvent, ITdDataTableSortChangeEvent, TdLoadingService } from '@covalent/core';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Location } from '@angular/common';
import { SalesService } from '../sales.service';
import { Sale } from '../sale';
import { InventoryService } from '../../inventory/inventory.service';
import { Piece } from '../../inventory/piece';
import { Branch } from '../../accounting/branch';
import { PoService } from '../../purchasing/pos/po.service';
import { PoBranch } from '../../purchasing/pos/poBranch';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { BranchService } from '../../accounting/branches/branch.service';
import { CustomerService } from '../../accounting/customer/customer.service';
import { Customer } from '../../accounting/customer';
import { SettingsService } from '../../../shared/services/settings.service';
import { ReportService } from '../../../shared/services/report.service';
import { Product } from '../../purchasing/products/product';
import { CreditDetailsComponent } from '../../../shared/dialogs/credit-details/credit-details.component';
import { MdDialogRef, MdCheckbox } from '@angular/material';
import { Utils } from '../../../shared/utils';
import { Grade } from '../../accounting/grade';
import { Fabrictype } from 'app/agatextscreens/purchasing/fabrictypes/fabrictype';
import { ProductService } from 'app/agatextscreens/purchasing/products/product.service';
@Component({
  selector: 'app-sales-new',
  templateUrl: './sales-new.component.html',
  styleUrls: ['./sales-new.component.scss'],
  providers: [CustomerService, ReportService]
})

export class SalesNewComponent implements OnInit {
  _loading: number = 0;

  _selectAll: boolean;
  _change_b2b_mode: boolean = false;

  allBranches$: Observable<Branch[]>;
  allFabricTypes$: Observable<Fabrictype[]>;
  availableUnits: string[] = ['Meters', 'Yards'];

  // inventory vars
  _selectedBranch: number = 0;
  _selectedFabricTypeId: number = 0;
  _selectedFabricType: Fabrictype = new Fabrictype();

  _selectedUnit: string = 'Meters';
  _selectedUnitMultiplier: number = 1;
  _selectedUnitSymbol: string = 'm';

  data: Sale;
  currentSale: Sale = new Sale();

  originalOrderTotal: number = 0;

  originalSale: Sale = new Sale();

  valid_salesmen: string[] = [];

  toBeTagged: any[] = [];

  subscription: Subscription = new Subscription();
  title: string;

  allBranches: Branch[];
  allGrades$: Observable<{ id: number, name: string }[]>;
  filteredBranches: Branch[];
  allCustomers: Customer[];
  filteredCustomers: Customer[];

  fromBranches$: Observable<Branch[]>;
  allExistingBranches: Branch[];

  availableStatuses: string[];

  allTypes$: Observable<string[]>;
  isEditMode: boolean;
  refundMode: boolean = false;

  existingInventory: Piece[];

  totalPiecesValue: number = 0;
  totalQtyValue: number = 0;
  totalValue: number = 0;
  totalMetersValue: number = 0;
  totalPriceByRowValue: number = 0;
  totalPriceByAllRowsValue: number = 0;
  discount: number = 10;
  shippingCharges: number = 100;
  totals: number = 0;
  totalUnitPrices: number = 0;
  allDesignColors$: Observable<string[]>;

  columns_existing: ITdDataTableColumn[] = [
    { name: 'collection', label: 'Collection', tooltip: 'some tooltip example' },
    { name: 'designColor', label: 'Design / Color' },
    { name: 'pieceNo', label: 'Piece #' },
    { name: 'lotNo', label: 'Lot #' },
    { name: 'grade_code', label: 'Grade' },
    { name: 'length', label: 'Qty (M)' },
    { name: 'length_y', label: 'Qty (y)' },
    { name: 'length_Msq', label: 'Qty (M²)' },
    { name: 'length_Sft', label: 'Qty (SqFt)' },
    { name: 'weight', label: 'Weight (Kg)' },
    { name: 'location', label: 'Location' }
  ];

  columns: ITdDataTableColumn[] = [
    { name: 'collection', label: 'Collection', tooltip: 'some tooltip example' },
    { name: 'designColor', label: 'Design / Color' },
    { name: 'pieceNo', label: 'Piece #' },
    { name: 'lotNo', label: 'Lot #' },
    { name: 'grade_code', label: 'Grade' },
    { name: 'quantity', label: 'Qty' },
    // { name: 'length_y', label: 'Qty (y)' },
    // { name: 'length_Msq', label: 'Qty (M²)' },
    // { name: 'length_Sft', label: 'Qty (SqFt)' },
    { name: 'unit_price', label: 'Unit Price' },
  ];

  // Selected Items
  items: Piece[] = [];
  nonPreparedItems: Piece[] = [];

  // Current Inventory
  filteredData: any[] = [];
  filteredTotal: number;
  searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  sortBy: string = 'id';
  selectedRows: any[];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;

  // Currency Symbol for displays
  _currency_symbol: string;
  _grade: Grade = new Grade;
  // Backorder-related info
  originalBackorder: string;
  useNumber: string;

  creditInfo: any = {};

  constructor(private _salesService: SalesService,
    private _customerService: CustomerService,
    private route: ActivatedRoute,
    private router: Router,
    private _dataTableService: TdDataTableService,
    private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    private _settingsService: SettingsService,
    private _viewContainerRef: ViewContainerRef,
    private _branchService: BranchService,
    private _inventoryService: InventoryService,
    private _productService: ProductService,
    private _reportService: ReportService,
    private _poService: PoService,
    private location: Location,
    public _authService: AuthenticationService) { }

  ngOnInit(): void {
    this.setLoading(true, 'loading');

    // this is for the 'sell from branch dropdown, which filters the inventory accordingly
    this.fromBranches$ = this._branchService.getBranches().do(bl => { this.allExistingBranches = bl });

    // Get the fabric types and set defaults
    this.route.paramMap
      .switchMap((params: ParamMap) => params.get('id')
        ? this.processEditSale(params.get('id'))
        : this.processNewSale())
      .subscribe((currentItem: Sale) => {
        this.currentSale = currentItem;

        console.log('requesting all fabric types');
        this.allFabricTypes$ = this._productService.getFabricTypes();
        this.allFabricTypes$.subscribe(
          response => {
            console.log("# fabric types: " + response.length);
  
            if (this.isEditMode) {
              // TODO edit mode

              if (this.currentSale.selected_fabric_type_id) {
                this._selectedFabricTypeId = this.currentSale.selected_fabric_type_id;

                // now set the unit dropdown
                this.allFabricTypes$.forEach(
                  (result: Fabrictype[]) => result.forEach(
                    (element: Fabrictype) => {
                      if (this.currentSale.selected_fabric_type_id === +element.id) {
                        console.log(this.currentSale.selected_unit);

                        if (element.unit_type == 'AREA') {
                          this.availableUnits = ['Meters²', 'SqFt'];
                          if (this.currentSale.selected_unit) {
                            this._selectedUnit = this.currentSale.selected_unit;
                          }

                        } else if (element.unit_type == 'LENGTH') {
                          this.availableUnits = ['Meters', 'Yards'];
                          if (this.currentSale.selected_unit) {
                            this._selectedUnit = this.currentSale.selected_unit;
                          }

                        } else {
                          this.availableUnits = ['Pieces'];
                          if (this.currentSale.selected_unit) {
                            this._selectedUnit = this.currentSale.selected_unit;
                          }
                        }

                        this.onUnitChange(this._selectedUnit);
                      }
                    }));
              }

            } else {
              // create mode
              this._selectedFabricTypeId = Number.parseInt(response[0].id);
              this.onFabricSelect(this._selectedFabricTypeId);
            }
  
            // And get pieces right after
            this.updateInventory(this.currentSale.serve_from_branch_id, this._selectedFabricTypeId);
  
          },
          error => {
            this._dialogService.openAlert({ title: 'Error!', message: 'Error retrieving fabric types' });
          });


        // If it was an existing Sale retrieve items
        if (this.currentSale.id != null) {
          this.title = this.currentSale.order_number;
          this.originalSale = Object.assign({}, this.currentSale);

          this._salesService.getSaleItems(this.currentSale.id + '').subscribe(
            response => {
              this.items = response;

              this.originalOrderTotal = this.totalProduct(this.items, 'quantity', 'unit_price') + (this.currentSale.shipping_charges * 1) - (this.currentSale.discount * 1);
              this.filter();
            }
          );

          // If it is in PREPARED or SHIPPED, get the not shipped items
          this._salesService.getItemsNotPrepared(this.currentSale.id + '').subscribe(
            response => {
              this.nonPreparedItems = response;
              this.filter();

              console.log(this.nonPreparedItems);
            }
          );

          if (this.currentSale.type == 'RETURN') {
            this.refundMode = true;
            this.allTypes$ = Observable.of(['RETURN']);
            this.currentSale.type = 'RETURN';
            this.availableStatuses = ['DRAFT', 'PROCESSED'];
          }

          // If this is a B2B originated sales, fix the branch and inventory
          if (this.isEditMode && !this.currentSale.customer_name) {
            console.log('B2B!', this.currentSale)
            this.updateInventory(this.currentSale.serve_from_branch_id);
            //this.updateTax(this.currentSale.branch_id);
          }

          this.getCustomerCreditInfo();
          this.updateTax(this.currentSale.branch_id, this.currentSale.tax != null);
        } else {
          // This one's new. Set default branch on load
          this.currentSale.branch_id = this._authService.getHomeBranch();
          this.currentSale.serve_from_branch_id = this.currentSale.branch_id;
          // And its tax
          this.updateTax(this.currentSale.branch_id);
          //And it's a sale
          this.currentSale.type = 'SALE';
        }

        this.setLoading(false, 'loading');
        this.availableStatuses = this.getAvailableStatuses();

        this.updateInventory(this.currentSale.serve_from_branch_id);

        this.filterSalesmen();
      });

    //this.allCustomers$ = this._salesService.getCustomerPrefixes();

    this._salesService.getCustomerPrefixes().subscribe(
      response => {
        this.allCustomers = response;
        this.filteredCustomers = response;
      }
    );
    this.availableStatuses = this.getAvailableStatuses();

    this.allTypes$ = this._salesService.getTypes();
    // Use user's branches instead
    this.allBranches = this._authService.getUserBranches();
    this.filteredBranches = this.allBranches;
  }

  preparedStatusText() {

    // TODO THIS quantity needs to be updated with units
    let totalPieces: number = this.items.length;
    let preparedPieces: number = this.items.filter(p => { return p.prepared_pallet_id }).length;
    let totalMeters: number = this.items.reduce((a, b) => { return a + b.quantity }, 0);
    let preparedMeters: number = this.items.filter(p => { return p.prepared_pallet_id }).reduce((a, b) => { return a + b.quantity }, 0);


    // there appears to be a typescript bug that doesn't recognize totalmeters as a number this forces it to a float

    //console.log("Prepared Meters: " + preparedMeters);
    //console.log("Total Meters: " + totalMeters);


    // there appears to be a typescript bug that doesn't recognize totalmeters as a number this forces it to a float
    return preparedPieces + '/' + totalPieces + ' pieces prepared, ' + parseFloat(preparedMeters.toString()).toFixed(2) + '/' + parseFloat(totalMeters.toString()).toFixed(2) + ' meters prepared';
  }

  preparedStatusValue() {
    let totalPieces: number = this.items.length;
    let preparedPieces: number = this.items.filter(p => { return p.prepared_pallet_id; }).length;

    return (preparedPieces / totalPieces) * 100;
  }

  filterSalesmen() {
    console.log(this.currentSale.branch_id);
    this._salesService.getUsersPerBranch(this.currentSale.branch_id + '').subscribe(
      response => {
        if (Array.isArray(response)) {
          this.valid_salesmen = response.map(i => i.first_name + ' ' + i.last_name);
        } else {
          this.valid_salesmen = [];
        }
      }
    );
  }

  selectTagAll() {
    // If all are tagged
    if (this.allTagged()) {
      this.items.forEach(i => { i['selected'] = false });
    } else {
      this.items.forEach(i => { i['selected'] = true });
    }
  }

  allTagged() {
    return (this.items.length == this.items.filter(i => { return i['selected'] }).length);
  }

  addTag() {
    this._dialogService.openPrompt({
      title: 'Enter tag',
      message: 'Enter tag to be associated to this piece'
    }).afterClosed().subscribe(
      tag => {
        if (tag) {
          this.items.filter(i => { return i['selected'] }).forEach(p => { p['tag'] = tag });
        }
      }
    );
  }

  displayTag(tag) {
    this._dialogService.openAlert({
      title: 'VIEW TAG',
      message: tag,
      closeButton: 'OK'
    })
  }

  onFabricSelect(fabricTypeId: number) {

    // Loop through all the observable responses (should only
    // be 1 response: the array of fabric types returned by the service)
    // then loop through the array of fabric types and check if it matches
    // the selected fabric type, if so set the selected fabric type to the element
    this.allFabricTypes$.forEach(
      (result: Fabrictype[]) => result.forEach(
        (element: Fabrictype) => {
          if (fabricTypeId === +element.id) {

            // this element is the selected fabric type
            this._selectedFabricType = element;
            this.currentSale.selected_fabric_type_id = +element.id;

            if (element.unit_type == 'AREA') {
              this.availableUnits = ['Meters²', 'SqFt'];
              this._selectedUnit = 'SqFt';

            } else if (element.unit_type == 'LENGTH') {
              this.availableUnits = ['Meters', 'Yards'];
              this._selectedUnit = 'Meters';

            } else {
              this.availableUnits = ['Pieces'];
              this._selectedUnit = 'Pieces';
            }

            this.onUnitChange(this._selectedUnit);
          }
        }));
  }

  onUnitChange(unit: string) {
    console.log(unit);
    // Show and hide columns based on selected unit

    this.currentSale.selected_unit = unit;

    switch (unit) {
      case 'Meters': {
        this._selectedUnitMultiplier = 1;
        this._selectedUnitSymbol = 'm';

        // meters
        this.columns_existing = [
          { name: 'collection', label: 'Collection', tooltip: 'some tooltip example' },
          { name: 'designColor', label: 'Design / Color' },
          { name: 'pieceNo', label: 'Piece #' },
          { name: 'lotNo', label: 'Lot #' },
          { name: 'grade_code', label: 'Grade' },
          { name: 'length', label: 'Qty (M)' },
          { name: 'weight', label: 'Weight (Kg)' },
          { name: 'location', label: 'Location' }
        ];

        break;
      }
      case 'Yards': {
        // yards
        this._selectedUnitMultiplier = 1.09361;
        this._selectedUnitSymbol = 'y';

        this.columns_existing = [
          { name: 'collection', label: 'Collection', tooltip: 'some tooltip example' },
          { name: 'designColor', label: 'Design / Color' },
          { name: 'pieceNo', label: 'Piece #' },
          { name: 'lotNo', label: 'Lot #' },
          { name: 'grade_code', label: 'Grade' },
          { name: 'length_y', label: 'Qty (y)' },
          { name: 'weight', label: 'Weight (Kg)' },
          { name: 'location', label: 'Location' }
        ];

        break;
      }
      case 'Meters²': {
        // meters squared
        this._selectedUnitMultiplier = 1;
        this._selectedUnitSymbol = 'm²';

        this.columns_existing = [
          { name: 'collection', label: 'Collection', tooltip: 'some tooltip example' },
          { name: 'designColor', label: 'Design / Color' },
          { name: 'pieceNo', label: 'Piece #' },
          { name: 'lotNo', label: 'Lot #' },
          { name: 'grade_code', label: 'Grade' },
          { name: 'length_Msq', label: 'Qty (M²)' },
          { name: 'weight', label: 'Weight (Kg)' },
          { name: 'location', label: 'Location' }
        ];

        break;
      }
      case 'SqFt': {
        // square feet
        this._selectedUnitMultiplier = 10.7639;
        this._selectedUnitSymbol = 'SqFt';

        this.columns_existing = [
          { name: 'collection', label: 'Collection', tooltip: 'some tooltip example' },
          { name: 'designColor', label: 'Design / Color' },
          { name: 'pieceNo', label: 'Piece #' },
          { name: 'lotNo', label: 'Lot #' },
          { name: 'grade_code', label: 'Grade' },
          { name: 'length_Sft', label: 'Qty (SqFt)' },
          { name: 'weight', label: 'Weight (Kg)' },
          { name: 'location', label: 'Location' }
        ];

        break;
      }
      default: {
        // none
        this._selectedUnitMultiplier = 1;
        this._selectedUnitSymbol = 'm';

        this.columns_existing = [
          { name: 'collection', label: 'Collection', tooltip: 'some tooltip example' },
          { name: 'designColor', label: 'Design / Color' },
          { name: 'pieceNo', label: 'Piece #' },
          { name: 'lotNo', label: 'Lot #' },
          { name: 'grade_code', label: 'Grade' },
          { name: 'length', label: 'Qty (M)' },
          { name: 'weight', label: 'Weight (Kg)' },
          { name: 'location', label: 'Location' }
        ];

        break;
      }
    }

  }

  filterCustomers() {
    this._customerService.getCustomersPerBranch(this.currentSale.branch_id + '').subscribe(
      (response: { id: string, customers: Customer[] }) => {
        this.filteredCustomers = response.customers.filter(
          (c: Customer) => {
            return this.allCustomers.some(
              (_c: Customer) => {
                return c.id == _c.id
              }
            );
          }
        );
      }
    );
  }

  filterBranches() {
    this._customerService.getOneCustomerBranches(this.currentSale.customer_id + '').subscribe(
      (response: { id: string, branches: Branch[] }) => {
        this.filteredBranches = response.branches.filter(
          (b: Branch) => {
            b.id = Number.parseInt(b.id + '');
            return this.allBranches.some(
              (_b: Branch) => {
                return b.id == _b.id
              }
            )
          }
        );
      }
    );
  }

  updateInventory(branchId: number, fabricId?: number) {
    this._inventoryService.getPieces(branchId, null, fabricId).subscribe(
      response => {
        this.existingInventory = response;
        this.filter();
      }
    );
  }

  updateTax($event, currency_only?: boolean) {
    this._branchService.getBranch($event).subscribe(
      response => {
        if (response.sales_tax != null && !currency_only) {
          this.currentSale.tax = response.sales_tax;
        }
        if (response.sales_tax2 != null && !currency_only) {
          this.currentSale.tax2 = response.sales_tax2;
        }
        // Update also the currency
        if (response.currency != null) {
          this._currency_symbol = response.currency;
        }
      }
    );
  }

  changed(): boolean {
    for (let prop in this.currentSale) {
      if (this.currentSale[prop] != this.originalSale[prop]) {
        return true;
      }
    }

    return false;
  }

  getSalesman($event) {
    this._customerService.getOneCustomer($event).subscribe(
      response => {
        this.currentSale.salesman = response.sales_person;
      }
    );
  }

  total(data: any[], field: string) {
    return data.reduce(function (a, b) { return Number.parseFloat(a) + Number.parseFloat(b[field]) }, 0);
  }

  totalProduct(data: any[], field1: string, field2: string) {
    return data.reduce(function (a, b) { return Number.parseFloat(a) + (Number.parseFloat(b[field1]) * Number.parseFloat(b[field2])) }, 0);
  }

  totalChecked(data: any[], field: string) {
    return data.reduce(function (a, b) { return Number.parseFloat(a) + Number.parseFloat(b['selected'] ? b[field] : 0) }, 0);
  }

  toggleSelectAll(value: boolean) {
    this.filteredData.forEach(
      function (d) {
        d.selected = value;
      }
    );
  }

  shouldSelectAll(): boolean {
    return this.filteredData.filter(
      function (d) {
        return d.selected
      }
    ).length == this.filteredData.length;
  }

  addItemsToOrder(items) {
    this.filteredData.forEach(
      (i) => {
        if (i.selected) {
          this.items.push(i);

          // Default the quantity to the whole length
          i.quantity = i.length;

          if (this.currentSale.type == 'B2B') {
            i.unit_price = 0;
          } else {
            i.unit_price = i.unit_price_eur * (this.allBranches.find((b) => { return b.id == this.currentSale.branch_id })).exchange_rate_euro;
          }

          if (this._change_b2b_mode) {
            i.unit_price = 0;
          }

          i.selected = false;
          this._selectAll = false;
        }
      }
    );

    this.sortItemsDesignColor();

    this.filter();
  }

  sortItemsDesignColor() {
    // Order items alphabetically
    this.items = this.items.sort(
      (a, b) => {
        // ignore collection on sort, only design then color
        return (a['design_name'] != b['design_name']) ?
          ((a['design_name'] > b['design_name']) ? 1 : -1) :
          ((a['color_name'] > b['color_name']) ? 1 : -1);
      }
    );
  }

  removeItem(id: number) {
    this.items = this.items.filter(
      (t) => {
        if (t.id == id) {

          return false;
        } else {
          return true;
        }
      });

    this.filter();
  }

  displayCreditDetails() {
    let creditDialog: MdDialogRef<CreditDetailsComponent> = this._dialogService.open(CreditDetailsComponent);

    creditDialog.componentInstance.details = this.creditInfo;
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  getCurrentCreditLimit(details) {
    if (!details.credit_margin || !Array.isArray(details.credit_margin)) details.credit_margin = [];
    details.credit_margin = details.credit_margin.sort((a, b) => { return (new Date(a.date) > new Date(b.date)) ? -1 : 1 });

    let credit: number;
    if (details.credit_margin.length > 0) {
      credit = details.credit_margin[0].margin;
    } else {
      credit = 0;
    }

    return credit;
  }

  getRemainingCredit(details) {
    return Number.parseFloat(this.getCurrentCreditLimit(details) + '') - (Number.parseFloat(details.invoices_outstanding || '0') + Number.parseFloat(details.orders_outstanding || '0'))
  }

  isWithinCreditLimits() {
    // Remove the original amount of this order from the total, since we are evaluating this particular order
    let _availableRoom: number = this.getRemainingCredit(this.creditInfo) + this.originalOrderTotal;
    let _thisOrderTotal: number = this.totalProduct(this.items, 'quantity', 'unit_price') + (this.currentSale.shipping_charges * 1) - (this.currentSale.discount * 1);

    return (_availableRoom >= _thisOrderTotal);
  }

  filter(): void {
    let newData: any[] = this.existingInventory ? this.existingInventory : [];
    //newData = this._dataTableService.filterData(newData, this.searchTerm, true);
    // Filter as an AND
    newData = newData.filter((d: Product) => {
      let _search: string = (this.searchTerm || '');

      return (d.design_name + '/' + d.color_name).toLowerCase().indexOf(_search.toLowerCase()) > -1;
    });
    // Do not display in the inventory the stuff that has been added already
    this.items.forEach(
      (i) => {
        newData = newData.filter((d) => { return d.id != i.id });
      }
    );

    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    // Sort the inventory based on design/color
    this.filteredData = newData.sort(
      (a, b) => {
        return (a['design_name'] != b['design_name']) ?
          ((a['design_name'] > b['design_name']) ? 1 : -1) :
          ((a['color_name'] > b['color_name']) ? 1 : -1);
      }
    );

    //Sort the items based on design/color
    this.sortItemsDesignColor();
  }

  openModifyTax1() {
    this._dialogService.openPrompt({
      message: 'Enter new GST value',
      viewContainerRef: this._viewContainerRef,
      title: 'Modify value',
      value: this.currentSale.tax + '',
      cancelButton: 'Cancel',
      acceptButton: 'Apply',
    }).afterClosed().subscribe((newValue: string) => {
      if (newValue) {
        this.currentSale.tax = Number.parseFloat(newValue);
      } else {
        console.log('No change');
      }
    });
  }

  openModifyTax2() {
    this._dialogService.openPrompt({
      message: 'Enter new QST value',
      viewContainerRef: this._viewContainerRef,
      title: 'Modify value',
      value: this.currentSale.tax2 + '',
      cancelButton: 'Cancel',
      acceptButton: 'Apply',
    }).afterClosed().subscribe((newValue: string) => {
      if (newValue) {
        this.currentSale.tax2 = Number.parseFloat(newValue);
      } else {
        console.log('No change');
      }
    });
  }

  enterNewValueDialog(row: Piece, attr: string, multiplier: number) {
    this._dialogService.openPrompt({
      message: 'Enter new value',
      viewContainerRef: this._viewContainerRef,
      title: 'Modify value',
      value: (Number.parseFloat(row[attr]) * multiplier).toString(),
      cancelButton: 'Cancel',
      acceptButton: 'Apply',
    }).afterClosed().subscribe((newValue: string) => {
      if (newValue) {
        let this_piece = this.existingInventory.find((i) => { return i.id == row.id });

        let maxValue: number = this_piece ? (attr == 'quantity' ? this_piece.length * multiplier : 9999999999) : 999999999;

        if (Number.parseFloat(newValue) > 0 && Number.parseFloat(newValue) <= maxValue) {
          row[attr] = (Number.parseFloat(newValue) / multiplier);
        } else {
          this._dialogService.openAlert({
            message: 'Invalid value. The value should be between 0 and ' + maxValue,
            title: 'Failed!',
          });
        }
      } else {
        console.log('DECLINED');
      }
    });
  }

  processEditSale(orderNumber: string): Observable<Sale> {
    this.title = 'Edit';
    this.isEditMode = true;
    return this._salesService.getOneSale(orderNumber);
  }

  processNewSale(): Observable<Sale> {
    this.title = 'New';
    this.isEditMode = false;
    return Observable.of(new Sale());
  }

  createB2BPo(po_number: string) {
    let branchPo: PoBranch = new PoBranch();

    this.setLoading(true, 'b2bpo');

    // When it's created, it is already in "ORDERED" status
    branchPo.status = 'ORDERED'
    // Figure out the branches
    branchPo.requesting_branch_id = this.currentSale.requesting_branch_id;
    branchPo.source_branch_id = this.currentSale.branch_id;

    // Set the number already
    branchPo.po_number = po_number;

    // Figure out the pieces
    branchPo.transferItems = [];
    this.items.forEach(
      piece => {
        branchPo.transferItems.push(Object.assign(new Piece(), {
          id: piece.id,
          length: piece.length,
          weight: piece.weight,
          tag: piece.tag
        }));
      }
    );

    this._poService.createBranchPo(branchPo).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          branchPo.po_id = response['id'];
          branchPo.po_number = response['po_number'];

          branchPo = Object.assign({}, branchPo);

          this.isEditMode = true;

          this._dialogService.openAlert({
            message: 'Purchase Order ' + branchPo.po_number + ' created successfully!',
            title: 'Success!',
          });
        } else {
          this._dialogService.openAlert({
            message: 'Could not create Branch Transfer ' + branchPo.po_number + '.',
            title: 'Failed!',
          });
        }

        this.setLoading(false, 'b2bpo');
      },
      error => {
        this._dialogService.openAlert({
          message: 'Error creating Branch Transfer ' + branchPo.po_number + ': ' + error,
          title: 'Error!',
        });

        this.setLoading(false, 'b2bpo');
      },
      () => { }
    );
  }

  createNewSalesOrder() {
    this.setLoading(true, 'loading');

    if (!this.currentSale.order_date || !this.currentSale.delivery_date) {
      this._dialogService.openAlert({
        title: 'Missing Data',
        message: "Please Enter an Order Date and Delivery Date",
        closeButton: 'OK'
      })

      this.setLoading(false, 'loading');
      return;
    }



    // Clean slate
    this.currentSale.items = [];
    this.items.forEach(
      (item) => {
        this.currentSale.items.push({
          id: item.id,
          quantity: item.quantity,
          unit_price: item.unit_price,
          tag: item.tag
        });
      }
    );

    // For B2B Direct, let's do a trick to name the order (SRC-DST-D-xxxxxxxx-yy)
    // The -D- is for "Direct" and it is crucial to later find the PO to which this sales order is related
    if (this.currentSale.type == 'B2B') {
      let _src_branch = this.allExistingBranches.find(b => { return b.id == this.currentSale.branch_id });
      let _dst_branch = this.allExistingBranches.find(b => { return b.id == this.currentSale.requesting_branch_id });

      this.currentSale.customer_prefix = (_src_branch.code || 'X') + '-' + (_dst_branch.code || 'X') + '-D';
    }

    // If there is a backorder associated, speak up now
    if (this.useNumber) this.currentSale.order_number = this.useNumber;

    // Create the sale
    this._salesService.createSale(this.currentSale).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          this.currentSale.id = response['id'];
          this.currentSale.order_number = response['order_number'];

          this.originalSale = Object.assign({}, this.currentSale);

          this.isEditMode = true;
          this._dialogService.openAlert({
            message: 'Sales Order ' + this.currentSale.order_number + ' created successfully!',
            title: 'Success!',
          }).afterClosed().subscribe((accept: boolean) => {
            if (this.originalBackorder) {
              this._dialogService.openConfirm({
                title: 'Associated Back Order',
                message: 'The back order ' + this.useNumber + ' is associated to this sales order. Do you want to mark it complete?',
                acceptButton: 'Yes',
                cancelButton: 'No'
              }).afterClosed().subscribe(
                result => {
                  if (result) {
                    this._salesService.getOneBackOrder(this.originalBackorder).subscribe(
                      _bo => {
                        _bo.status = 'COMPLETED';

                        console.log(_bo);
                        this._salesService.updateBackOrder(_bo.id, _bo).subscribe(
                          response => {

                          }
                        );
                      }
                    );
                  }
                }
              )
            }
            // If we are creating a new B2B and we are going straight to reserved status, create B2B PO
            console.log(this.currentSale.type, this.currentSale.status, this.isReserved());
            if (this.currentSale.type == 'B2B' && this.isReserved()) {
              this.createB2BPo(this.currentSale.order_number);
            }
            this.router.navigate(['/sales', 'list']);
          });
        } else {
          this._dialogService.openAlert({
            message: 'Could not create Sales Order ' + this.currentSale.order_number + '.',
            title: 'Failed!',
          });
        }

        //Refund the pieces
        if (this.currentSale.type == 'RETURN') {
          this.refund();
        }

        this.setLoading(false, 'loading');

      },
      error => {
        this._dialogService.openAlert({
          message: 'Error creating Sales Order ' + this.currentSale.order_number + ': ' + error,
          title: 'Error!',
        });
        this.setLoading(false, 'loading');

      },
      () => { }
    );
  }

  changeB2B() {
    this._dialogService.openConfirm(
      {
        title: 'Confirm',
        message: 'You are about to change the original Branch-to-Branch PO. Are you sure?',
        acceptButton: 'Yes',
        cancelButton: 'No'
      }
    ).afterClosed().subscribe(
      result => {
        if (result) {
          this._change_b2b_mode = true;
        };
      }
    );
  }

  updateSalesOrder() {

    this.setLoading(true, 'loading');

    if (!this.currentSale.order_date || !this.currentSale.delivery_date) {
      this._dialogService.openAlert({
        title: 'Missing Data',
        message: "Please Enter an Order Date and Delivery Date",
        closeButton: 'OK'
      })
      this.setLoading(false, 'loading');
      return;
    }

    //If we modify an approved order that's not B2B and it is beyond limit, complain
    if (this.currentSale.type != 'B2B' && this.isApproved() && !this.isWithinCreditLimits()) {
      this._dialogService.openConfirm(
        {
          title: 'Problem',
          message: 'By saving the order as it is, it will go beyond this customer\'s credit limit and therefore it needs re-approval. Do you want to set it back to "RESERVED" status?'
        }
      ).afterClosed().subscribe(
        answer => {
          if (answer) {
            this.currentSale.status = 'RESERVED';
            this.updateSalesOrder();
          }

          this.setLoading(false, 'loading');
        }
      );

      return;
    }

    if (this._change_b2b_mode) {

      this.setLoading(true, 'change');

      this._dialogService.openConfirm(
        {
          title: 'Confirm',
          message: 'You are going to change the original B2B PO. Are you sure?',
          acceptButton: 'Yes',
          cancelButton: 'No'
        }).afterClosed().subscribe(
          result => {
            if (result) {
              // Adjust the original PO
              this._poService.getBranchPoByNumber(this.currentSale.order_number).subscribe(
                (response: PoBranch) => {
                  // Update the PO items
                  response.transferItems = this.items;
                  // Call the "ID" "Piece_ID" and 
                  response.transferItems.forEach(p => { p.piece_id = p.id; p.length = p.length ? p.length : p.quantity });
                  // Then update
                  console.log(response);
                  this._poService.updateBranchPo(response.po_id, response).subscribe(
                    response => {
                      this._dialogService.openAlert(
                        {
                          title: 'Success!',
                          message: 'B2B Purchase Order has been updated successfully'
                        }
                      );
                      this.setLoading(false, 'change');

                    },
                    error => {
                      this._dialogService.openAlert(
                        {
                          title: 'Failed!',
                          message: 'Could not update purchase order'
                        }
                      )

                      this.setLoading(false, 'change');
                    }
                  );
                }
              );
              // Then update the sales order
              this.doUpdateSalesOrder();
            }
          }
        );
    } else {
      this.doUpdateSalesOrder();
    }
  }

  doUpdateSalesOrder() {

    this.setLoading(true, 'update');

    // Clean slate
    this.currentSale.items = [];
    this.items.forEach(
      (item) => {
        this.currentSale.items.push({
          id: item.id,
          quantity: item.quantity,
          unit_price: item.unit_price,
          tag: item.tag
        });
      }
    );

    this._salesService.updateSale(this.currentSale.id, this.currentSale).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          this._dialogService.openAlert({
            message: 'Sales Order ' + this.currentSale.order_number + ' updated successfully!',
            title: 'Success!',
          }).afterClosed().subscribe((accept: boolean) => {

            // If this is a B2B PO that was DRAFT and it has been moved to RESERVED now, create a B2B PO
            if (this.currentSale.type == 'B2B' && this.originalSale.status == 'DRAFT' && this.currentSale.status == 'RESERVED') {
              this.createB2BPo(this.currentSale.order_number);
            }

            this.originalSale = Object.assign({}, this.currentSale);

            this.router.navigate(['/sales', 'list']);
          });
        } else {
          this._dialogService.openAlert({
            message: 'Could not update Sales Order ' + this.currentSale.order_number + '.',
            title: 'Failed!',
          });
        }
        this.setLoading(false, 'update');

      },
      error => {
        this._dialogService.openAlert({
          message: 'Error updating Sales Order ' + this.currentSale.order_number + ': ' + error,
          title: 'Error!',
        });
        this.setLoading(false, 'update');

      },
      () => { }
    );
  }

  acceptB2B() {
    this._dialogService.openConfirm(
      {
        title: 'Confirm action',
        message: 'Are you sure you want to accept Branch to branch transfer sale?',
        acceptButton: 'Yes',
        cancelButton: 'No'
      }
    ).afterClosed().subscribe(
      result => {
        // YES -> result == true
        // NO  -> result == false
        // Click outside -> result == undefined
        if (result) {
          // If confirmed, The system saves the details and sets the PO status to “Approved”
          this.currentSale.status = 'APPROVED';
          this.updateSalesOrder();
          this._poService.getBranchPoByNumber(this.currentSale.order_number).subscribe(
            (response: PoBranch) => {
              response.status = 'APPROVED';
              this._poService.updateBranchPo(response.po_id, response).subscribe(
                response => {
                  this._dialogService.openAlert(
                    {
                      title: 'Approved!',
                      message: 'Order has been approved successfully'
                    }
                  );
                },
                error => {
                  this._dialogService.openAlert(
                    {
                      title: 'Failed!',
                      message: 'Could not approve order'
                    }
                  )
                }
              );
            }
          );
        }
      }
    );
  }

  backToReserved() {
    this._dialogService.openConfirm(
      {
        title: 'Confirm action',
        message: 'You are about to send the order back to RESERVED status. It will need to be re-approved once it is edited. Also, any piece that was already prepared will stay in the prepared location and you will need to manually change its location if it is not needed anymore.',
        acceptButton: 'Confirm',
        cancelButton: 'Cancel'
      }
    ).afterClosed().subscribe(
      answer => {
        if (answer) {
          this.currentSale.status = 'RESERVED';
          this.updateSalesOrder();
        }
      }
    );
  }

  cancelOrder() {
    this._dialogService.openConfirm(
      {
        title: 'Confirm action',
        message: 'You are about to CANCEL the order. This cannot be undone. Also, any piece that was already prepared will stay in the prepared location and you will need to manually change its location if it is not needed anymore.',
        acceptButton: 'Confirm',
        cancelButton: 'Cancel'
      }
    ).afterClosed().subscribe(
      answer => {
        if (answer) {
          this.currentSale.status = 'CANCELLED';
          this.updateSalesOrder();
        }
      }
    );
  }

  declineB2B() {
    this._dialogService.openPrompt(
      {
        title: 'Confirm action',
        message: 'You are about to decline the transfer and must supply a reason',
        acceptButton: 'Confirm',
        cancelButton: 'Cancel'
      }
    ).afterClosed().subscribe(
      result => {
        // CONFIRM -> result == : string
        // CANCEL  -> result == undefined
        // Click outside -> result == undefined
        if (result != null && result != '') {
          // If confirmed, The system saves the details and sets the PO status to Declined
          this.currentSale.status = 'DECLINED';
          this.currentSale.notes = 'Declined. Reason: ' + result;
          this.updateSalesOrder();
          this._poService.getBranchPoByNumber(this.currentSale.order_number).subscribe(
            (response: PoBranch) => {
              response.status = 'DECLINED';
              this._poService.updateBranchPo(response.po_id, response).subscribe(
                response => {
                  this._dialogService.openAlert(
                    {
                      title: 'Declined!',
                      message: 'Order has been declined successfully'
                    }
                  );
                },
                error => {
                  this._dialogService.openAlert(
                    {
                      title: 'Failed!',
                      message: 'Could not decline order'
                    }
                  )
                }
              );
            }
          );
        }
      }
    );
  }

  getCustomerCreditInfo() {
    this._customerService.getOneCustomerCreditLimitInfo(this.currentSale.customer_id).subscribe(
      cInfo => {
        this.creditInfo = cInfo;
      }
    );
  }

  displayCreditInfo() {
    return JSON.stringify(this.creditInfo)
  }

  generatePackingList() {
    this._branchService.getBranch(this.currentSale.branch_id).subscribe(
      branch => {
        this._customerService.getOneCustomer(this.currentSale.customer_id + '').subscribe(
          customer => {
            if (customer) {
              this._reportService.packingList(this.currentSale, this.items, branch, customer);
            } else {
              this._reportService.packingList(this.currentSale, this.items, branch, new Customer());
            }
          }
        );
      }
    )
  }

  generateOrderConfirmation() {
    this._branchService.getBranch(this.currentSale.branch_id).subscribe(
      branch => {
        this._customerService.getOneCustomer(this.currentSale.customer_id + '').subscribe(
          customer => {
            if (customer) {
              this._reportService.orderConfirmation(this.currentSale, this.items, customer, branch);
            } else {
              this._reportService.orderConfirmation(this.currentSale, this.items, new Customer(), branch);
            }
          }
        );
      }
    )
  }

  generateLocalInvoice() {
    this._branchService.getBranch(this.currentSale.branch_id).subscribe(
      (branch: Branch) => {
        this._customerService.getOneCustomer(this.currentSale.customer_id + '').subscribe(
          (customer: Customer) => {
            if (customer) {
              this._reportService.localInvoice(this.currentSale, this.items, customer, branch);
            } else {
              this._reportService.localInvoice(this.currentSale, this.items, new Customer(), branch);
            }
          }
        );
      }
    );
  }

  generateExportInvoice() {
    this._branchService.getBranch(this.currentSale.branch_id).subscribe(
      (branch: Branch) => {
        this._customerService.getOneCustomer(this.currentSale.customer_id + '').subscribe(
          (customer: Customer) => {
            if (customer) {
              this._reportService.exportInvoice(this.currentSale, this.items, customer, branch);
            } else {
              this._reportService.exportInvoice(this.currentSale, this.items, new Customer(), branch);
            }
          }
        );
      }
    );
  }

  getPrefixForCustomerId(id: number) {
    this.currentSale.customer_prefix = this.allCustomers.find(
      (c) => {
        return Number.parseInt(c.id) == id;
      }
    )['prefix'];

  }

  getPrefixForCustomerName(name: string) {
    let customer = this.allCustomers.find(
      (c) => {
        return c.name == name;
      }
    );

    if (customer) {
      this.currentSale.customer_id = Number.parseInt(customer.id);
      this.currentSale.customer_prefix = customer.prefix;

      // And get other stuff too
      this.getSalesman(this.currentSale.customer_id);
      this.filterBranches();
      this.getCustomerCreditInfo();
    }
  }

  refund() {
    this.setLoading(true, 'refund');

    this.items.forEach(
      (item: Piece) => {
        this._inventoryService.refundPiece(item).subscribe(
          response => {
            this.setLoading(false, 'refund');
          },
          error => {
            this.setLoading(false, 'refund');
          }
        );
      }
    );
  }

  customerOptions(search: string) {
    return (this.filteredCustomers || []).filter(value => (value.name || '').toLowerCase().indexOf((search || '').toLowerCase()) === 0);
  }

  goBack(): void {
    this.location.back();
  }

  getAvailableStatuses(): string[] {
    // On new entry only DRAFT
    if (this.isEditMode == false) {
      return ['DRAFT', 'RESERVED'];
    }

    switch (this.currentSale.status) {
      // If it was draft, can be DRAFT, RESERVED
      case 'DRAFT':
        return ['DRAFT', 'RESERVED'];

      // If it was RESERVED, can move to APPROVED or DECLINED (only for admins)
      case 'RESERVED':
        if (this._authService.isAdmin() && this._authService.hasRole('Sales')) {
          return ['RESERVED', 'APPROVED', 'DECLINED'];
        } else {
          return ['RESERVED'];
        }

      // If it was DECLINED, then it's end of the game
      case 'DECLINED':
        return ['DECLINED'];

      // Else you can't move status in here
      default:
        return [this.currentSale.status];
    }

  }

  isDraft(): boolean {
    if (this.currentSale == null) return false;

    switch (this.currentSale.status) {
      case 'DRAFT':
      case 'RESERVED':
      case 'DECLINED':
      case 'APPROVED':
      case 'PREPARING':
      case 'PREPARED':
      case 'SHIPPED':
      case 'RECEIVED':
        return true;
      default:
        return false;
    }
  }

  wasDraft(): boolean {
    if (this.originalSale == null) return false;

    switch (this.originalSale.status) {
      case 'DRAFT':
      case 'RESERVED':
      case 'DECLINED':
      case 'APPROVED':
      case 'PREPARING':
      case 'PREPARED':
      case 'SHIPPED':
      case 'RECEIVED':
        return true;
      default:
        return false;
    }
  }

  isReserved(): boolean {
    if (this.currentSale == null) return false;

    switch (this.currentSale.status) {
      case 'DRAFT':
        return false;
      case 'RESERVED':
      case 'DECLINED':
      case 'APPROVED':
      case 'PREPARING':
      case 'PREPARED':
      case 'SHIPPED':
      case 'RECEIVED':
        return true;
      default:
        return false;
    }
  }

  wasReserved(): boolean {
    if (this.originalSale == null) return false;

    switch (this.originalSale.status) {
      case 'DRAFT':
        return false;
      case 'RESERVED':
      case 'DECLINED':
      case 'APPROVED':
      case 'PREPARING':
      case 'PREPARED':
      case 'SHIPPED':
      case 'RECEIVED':
        return true;
      default:
        return false;
    }
  }

  isDeclined(): boolean {
    if (this.currentSale == null) return false;

    switch (this.currentSale.status) {
      case 'DRAFT':
      case 'RESERVED':
      case 'APPROVED':
      case 'PREPARED':
      case 'PREPARING':
      case 'SHIPPED':
      case 'RECEIVED':
        return false;
      case 'DECLINED':
        return true;
      default:
        return false;
    }
  }

  setLoading(loading: boolean, name: string) {
    if (loading) {
      this._loadingService.register(name);
      this._loading++;
    }
    else {
      this._loadingService.resolve(name);
      this._loading--;
    }
  }

  isLoading(): boolean {
    return this._loading > 0;
  }

  isCancelled(): boolean {
    if (this.currentSale == null) return false;

    return this.currentSale.status == 'CANCELLED'
  }

  isApproved(): boolean {
    if (this.currentSale == null) return false;

    switch (this.currentSale.status) {
      case 'DRAFT':
      case 'RESERVED':
      case 'DECLINED':
      case 'SHIPPED':
      case 'RECEIVED':
        return false;
      case 'APPROVED':
      case 'PREPARING':
      case 'PREPARED':
        return true;
      default:
        return false;
    }
  }

  wasApproved(): boolean {
    if (this.originalSale == null) return false;

    switch (this.originalSale.status) {
      case 'DRAFT':
      case 'RESERVED':
      case 'DECLINED':
        return false;
      case 'APPROVED':
      case 'PREPARING':
      case 'PREPARED':
      case 'SHIPPED':
      case 'RECEIVED':
        return true;
      default:
        return false;
    }
  }

  isPreparing(): boolean {
    if (this.currentSale == null) return false;

    switch (this.currentSale.status) {
      case 'DRAFT':
      case 'RESERVED':
      case 'DECLINED':
      case 'APPROVED':
        return false;
      case 'PREPARING':
      case 'PREPARED':
      case 'SHIPPED':
      case 'RECEIVED':
        return true;
      default:
        return false;
    }
  }

  isPrepared(): boolean {
    if (this.currentSale == null) return false;

    switch (this.currentSale.status) {
      case 'DRAFT':
      case 'RESERVED':
      case 'DECLINED':
      case 'APPROVED':
      case 'PREPARING':
        return false;
      case 'PREPARED':
      case 'SHIPPED':
      case 'RECEIVED':
        return true;
      default:
        return false;
    }
  }

  isShipped(): boolean {
    if (this.currentSale == null) return false;

    switch (this.currentSale.status) {
      case 'DRAFT':
      case 'RESERVED':
      case 'DECLINED':
      case 'APPROVED':
      case 'PREPARING':
      case 'PREPARED':
        return false;
      case 'SHIPPED':
      case 'RECEIVED':
        return true;
      default:
        return false;
    }
  }

  isReceived(): boolean {
    if (this.currentSale == null) return false;

    switch (this.currentSale.status) {
      case 'DRAFT':
      case 'RESERVED':
      case 'DECLINED':
      case 'APPROVED':
      case 'PREPARING':
      case 'PREPARED':
      case 'SHIPPED':
        return false;
      case 'RECEIVED':
        return true;
      default:
        return false;
    }
  }
}





/*
this.route.queryParams.subscribe(
  params => {
    /*Refund stuff should go away*/

    /*
    this.refundMode = new Boolean(params['refund']).valueOf();
    if (this.refundMode) {
      console.log('this is a Return!');
      this.isEditMode = false;
      //Prepare as a new order
      this.currentSale.order_number += '-R';
      this.currentSale.discount = -this.currentSale.discount;
      this.currentSale.shipping_charges = -this.currentSale.shipping_charges;
      this.currentSale.type = 'RETURN';
      this.currentSale.status = 'DRAFT';
      this.currentSale.delivery_date = (new Date()).toISOString().substr(0, 10);
      this.currentSale.order_date = (new Date()).toISOString().substr(0, 10);

      this.allTypes$ = Observable.of(['RETURN']);
      this.availableStatuses = ['DRAFT', 'PROCESSED'];

      this.items.forEach(
        (item: Piece) => {
          item.unit_price = -item.unit_price;
        }
      );
    }
    */

    /*Get the backorder data*/
    /*
    if (params['fromBackorder']) {
      this.originalBackorder = params['fromBackorder'];
      this.useNumber = params['useNumber'];

      this._salesService.getOneBackOrder(this.originalBackorder).subscribe(
        response => {
          this.currentSale = response;

          this.currentSale.status = 'DRAFT';
          this.currentSale.delivery_date = new Date().toISOString().substr(0, 10);
          this.currentSale.order_date = new Date().toISOString().substr(0, 10);
        }
      );
    }
    
  }
);
*/



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/sales/sales-new/sales-new.component.ts